import { PERSONAL_ID_LOCKED_SAVED } from '@/utils/giving-login';

/**
 * Member/app-user split, phase 4b. A login waiting for its leader's link changes its own
 * registration at once (decided 2026-10-28): POST /v2/profile/pid-update-request rewrites
 * its partial NRIC and dob, POST /v2/profile/cg-update-request moves its claimed CG. No
 * staff ticket is raised, so nothing here may say "we'll review it" or "we'll email you".
 */

/** The personal-id card once the correction is written. */
export function personalIdUpdatedTitle(personalId) {
  return personalId
    ? `Updated ✅ Your personal ID is now ${personalId}`
    : 'Updated ✅ Your NRIC and date of birth have been updated.';
}

/** The Church Life card once the claimed CG has moved: that CG's leader now links it. */
export function cgUpdatedTitle(cgName) {
  return `Your Connect Group is now ${cgName}. Its leader will link your account.`;
}

/**
 * Next Steps' CG block for a login: its save moves the claimed CG by id, which only the
 * CG directory gives, and the directory is fetched as the block opens — it can still be
 * loading, or have failed. Says nothing about a link: that is the leader's to make.
 */
export const CG_DIRECTORY_UNAVAILABLE = "We couldn't check that CG just now. Please try again.";

/**
 * A profile save that wrote everything but a changed NRIC or dob (403 PERSONAL_ID_LOCKED).
 * The login corrects those on its own personal-id card, not in MyGiving.
 */
export const PERSONAL_ID_LOCKED_SAVED_UNLINKED =
  'Changes saved. To correct your NRIC or date of birth, use “Request for an update” below them.';

export function personalIdLockedSavedMessage(hasNoMember) {
  return hasNoMember ? PERSONAL_ID_LOCKED_SAVED_UNLINKED : PERSONAL_ID_LOCKED_SAVED;
}
